var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none",
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7E57C2",
    d: "M16.598 13.863c1.516 0 2.767-1.22 2.767-2.757v-8.35C19.365 1.247 18.14 0 16.598 0H2.766C1.25 0 0 1.22 0 2.757v8.349c0 1.325.958 2.439 2.234 2.677v2.465c0 .292.107.583.32.769.212.185.452.291.718.291.266 0 .532-.106.718-.291l3.139-3.154h9.47zm-6.144-3.048c0 .238-.187.424-.426.424H8.911c-.24 0-.426-.186-.426-.425V10.1c0-.239.187-.424.426-.424h1.117c.24 0 .426.185.426.424v.716zm-3.671-6.07c.053-.663.293-1.193.771-1.538.532-.397 1.224-.61 2.102-.61.93 0 1.675.24 2.207.716.533.477.799 1.114.799 1.909 0 .503-.134.954-.426 1.351-.293.398-.665.716-1.117.955-.24.159-.426.344-.506.53-.08.132-.106.291-.133.503-.026.16-.16.266-.319.266H8.805c-.187 0-.346-.133-.32-.319.027-.397.107-.689.266-.9.213-.292.559-.61 1.064-.955.266-.159.453-.371.612-.61.16-.265.24-.53.24-.848 0-.344-.08-.61-.267-.795-.16-.186-.425-.292-.744-.292-.266 0-.48.08-.665.239-.107.106-.186.239-.24.398-.053.185-.24.318-.452.318l-1.25-.027c-.16 0-.266-.132-.266-.291z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.8,
    d: "M2.634 13.783v-.332l-.326-.061C1.216 13.186.4 12.234.4 11.106v-8.35C.4 1.445 1.467.4 2.766.4h13.832c1.32 0 2.367 1.066 2.367 2.357v8.349c0 1.313-1.068 2.357-2.367 2.357H6.962l-.117.118-3.137 3.152v.001c-.109.107-.272.174-.436.174-.15 0-.3-.057-.456-.193-.106-.093-.182-.263-.182-.467v-2.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.12 22c-.133 0-.266-.053-.372-.159l-3.299-3.26H7.74c-1.117 0-2.048-.796-2.207-1.882l.824-.822v.477c0 .769.612 1.379 1.383 1.379h10.082l2.926 2.915v-2.915h.85c.772 0 1.384-.61 1.384-1.379V7.978c0-.768-.612-1.378-1.383-1.378h-1.144v-.875H21.6c1.224.027 2.234 1.034 2.234 2.253v8.35c0 1.033-.744 1.961-1.782 2.173l-.425.08v2.889c0 .291-.24.53-.506.53z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H23.833V22H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.5ccca2312224be1ce67b28548d2151fc.svg";
export { ForwardRef as ReactComponent };